import getFileSpriteIconClass from './utils/getFileSpriteIconClass';
import getIconForFile, { FileIcon, getFileIconFromSprite } from './utils/getIconForFile';

// Type - not delay loaded
export { FileIcon, getFileSpriteIconClass, getIconForFile, getFileIconFromSprite };
